import BaseService from './BaseService';
import apiClient from '../plugins/axios';

class PermissionService extends BaseService {
  constructor() {
    super('permission');
  }

  async getAll() {
    try {
      const response = await apiClient.get('/permissions');
      return response.data.data || response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async createPermission(permissionData) {
    try {
      const response = await apiClient.post('/permission', permissionData);
      return response.data.data || response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async getPermissionById(id) {
    try {
      const response = await apiClient.get(`/permission/${id}`);
      return response.data.data || response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async deletePermission(id) {
    try {
      const response = await apiClient.delete(`/permission/${id}`);
      return response.data.data || response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }
}

export default new PermissionService();
